import { BASE_URL, ENDPOINT_URL } from "../../config/urlConfig.js";
import { ApiService } from "../../config/apiServices.js";
import { encryptJsonPayload, getPublicKey } from "../../utils/encryption.js";

/**
 * Utility: encrypt payload then POST. Falls back to plain POST on error.
 */
const encryptedPost = async (methodUrl, data) => {
  try {
    const publicKey = getPublicKey();

    if (publicKey) {
      const encryptedPayload = await encryptJsonPayload(data, publicKey);
      return ApiService.post(methodUrl, encryptedPayload);
    }

    console.warn("No public key found - sending unencrypted data");
    return ApiService.post(methodUrl, data);
  } catch (error) {
    console.error("Encryption error:", error);
    return ApiService.post(methodUrl, data);
  }
};

// Create key generation
export const keygenrerationApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.keygenreration.create;
  return encryptedPost(METHOD_URL, data);
};

export const ElementsSidebarApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.elements.left_side_bar;
  return encryptedPost(METHOD_URL, data);
};

export const getGenerationkeysApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.keygenreration.getGenerationkeys;
  return encryptedPost(METHOD_URL, data);
};

export const sentemailApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.keygenreration.sent;
  return encryptedPost(METHOD_URL, data);
};

export const CreateSticherApis = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.sticher.create;
  return encryptedPost(METHOD_URL, data);
};

export const getGenerationkeysforStciherApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.keygenreration.listofGenratescreener;
  return encryptedPost(METHOD_URL, data);
};
